import { helperConstants as constants } from "../helpers/helperConstants";
import axios from "../lib/axios";
import useAdaptor from "../lib/swr";
import { ethers } from "ethers";

export default function useGetGlobalLendOffers({
  collectionAddresses,
  page = 1,
  limit = 10,
}: // sort,
// search = "",
{
  collectionAddresses?: string[];
  page?: number;
  limit?: number;
  // sort?: string;
  // search?: string;
}) {
  let config: { url: string; method: string; params: any } | {};

  config = {
    url: `${constants.api.url_new}/lend-orders/globalLendOffers`,
    method: constants.httpMethods.get,
    params: {
      collectionAddresses,
      limit,
      page,
    },
  };

  const fetcher = () =>
    axios(config).then((response) => {
      return response.data;
    });

  const isReady =
    collectionAddresses && collectionAddresses.length > 0
      ? collectionAddresses.every((address) => ethers.utils.isAddress(address))
      : true;
  return useAdaptor(isReady ? axios.getUri(config) : null, fetcher);
}
